module.exports = __webpack_public_path__ + "assets/img/37_1526_big.cf1c1480.jpg";